module.exports = __webpack_public_path__ + "img/krill_logo_white.svg";